import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService } from 'ng-jhipster';

import { Contractdate } from './contractdate.model';
import { ContractdatePopupService } from './contractdate-popup.service';
import { ContractdateService } from './contractdate.service';

@Component({
    selector: 'jhi-contractdate-delete-dialog',
    templateUrl: './contractdate-delete-dialog.component.html'
})
export class ContractdateDeleteDialogComponent {

    contractdate: Contractdate;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private contractdateService: ContractdateService,
        public activeModal: NgbActiveModal,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['contractdate']);
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    confirmDelete(id: number) {
        this.contractdateService.delete(id).subscribe((response) => {
            this.eventManager.broadcast({
                name: 'contractdateListModification',
                content: 'Deleted an contractdate'
            });
            this.activeModal.dismiss(true);
        });
    }
}

@Component({
    selector: 'jhi-contractdate-delete-popup',
    template: ''
})
export class ContractdateDeletePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private contractdatePopupService: ContractdatePopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe((params) => {
            this.modalRef = this.contractdatePopupService
                .open(ContractdateDeleteDialogComponent, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/contractdate/contractdate-delete-dialog.component.ts